import { useState } from "react";
import { Checkbox } from "@mui/material";
import { ThemeInput, ThemeSelect } from "components/components";
import { Button, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

const Authorize = () => {
  const [showFields, setShowFields] = useState(false);
  const onChange = (e) => {
    setShowFields(e.target.checked);
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(
      "https://demo-saas.worksuite.biz/paypal-webhook/3a835e0ccbbd218f87c62a440878d64d"
    );
    message.success("Webhook URL Copied!");
  };
  return (
    <div className="bg-themeGray-light200 p-3 -mt-4 -ml-2 min-h-[70vh] desktop:h-[76vh] bigDesktop:h-[83vh]">
      <div className="bg-white p-3 shadow-md">
        <div className="flex items-center">
          <Checkbox onChange={onChange} />
          <p>Authorize Status</p>
        </div>
        {showFields && (
          <div>
            <ThemeSelect
              className={"!my-2"}
              label={"Select Environment"}
              data={["Sandbox", "Live"]}
            />
            <ThemeInput placeholder={"Authorize Api Login Id"} password />
            <ThemeInput placeholder={"Authorize Transaction Key"} password />
            <Button
              type="primary"
              className="mt-2 w-full"
              onClick={() => message.success("Successfully saved settings")}
            >
              Save
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Authorize;
